import { render, staticRenderFns } from "./MoreInfoModalMulti.vue?vue&type=template&id=00b96fc9&"
import script from "./MoreInfoModalMulti.vue?vue&type=script&lang=js&"
export * from "./MoreInfoModalMulti.vue?vue&type=script&lang=js&"
import style0 from "./MoreInfoModalMulti.vue?vue&type=style&index=0&id=00b96fc9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports